import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div>
      <h2>{`Data Collected by our SDK`}</h2>
      <h3>{`Details`}</h3>
      <p>
    Apple will require developers to provide information about their app's privacy practices in App Store Connect,
    including the practices of third-party partners whose code is integrated into their app. To make this process easier
    for you, we've provided the following list of boxes you will be required check when submitting your app to the App
    Store if your app integrates the GIPHY SDK.
      </p>
      <p>
    <i>
        We deeply respect the privacy of your users and only collect anonymized information about GIPHY use in order to
        improve the service. If you have any questions or concerns about GIPHY's data collection practices, please reach
        out to <a href="mailto:developers@giphy.com">developers@giphy.com</a>
    </i>
      </p>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Title`}</th>
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Description`}</th>
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Data use`}</th>
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Linked to user`}</th>
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Tracking`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Search History`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Information about searches performed in the app`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Analytics, Product Personalization, App Functionality`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`No`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`No`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Product Interaction`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Such as app launches, taps, clicks, scrolling information, music listening data, video views, saved place in a game, video, or song, or other information about how the user interacts with the app`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Analytics, Product Personalization, App Functionality`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`No`}</td>
            <td parentName="tr" {...{
              "align": "left"
            }}>{`No`}</td>
          </tr>
        </tbody>
      </table>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      